import { svgStrToDataUrl } from "@/common/svg"
import { deleteNozzleShape, getNozzleShapes } from "@/services/admin/nozzle-shape/NozzleShape.service"
import { useRequest } from "ahooks"
import { Button, Space, Table } from "antd"
import styles from './index.module.less';
import { CreateEditNozzleShape } from "./CreateEditNozzleShape"


export const NozzleShapes = () => {
  const { data, loading, refresh } = useRequest(() => getNozzleShapes())

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Image',
      dataIndex: 'svg',
      key: 'svg',
      render: (svg) => {
        if (!svg) return '-'
        return <img src={svgStrToDataUrl(svg)} className={styles.nozzleImg} />
      }
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (item) => {
        return <Space>
          <Button onClick={() => {
            CreateEditNozzleShape.show({nozzleShape: item, onSuccess: () => {
              refresh()
            }})
          }}>Edit</Button>
          <Button danger onClick={async () => {
            await deleteNozzleShape(item.id)
            refresh()
          }}>Delete</Button>
        </Space>
      }
    },
  ]

  return <div>
    <div className="actionRow">
      <Button type='primary' onClick={() => {
        CreateEditNozzleShape.show({onSuccess: () => {
          refresh()
        }})
      }}>Create Nozzle Shape</Button>
    </div>
    <div className="tableContainer mt-2">
      <Table columns={columns} dataSource={data}/>
    </div>
  </div>
}